import { FilterControlSettings } from '../../../types/FilterControlSettings';
import { ViewFilterName } from '../../../enum/types/ViewFilterName';
import { FormControlType } from '../../../../../components/forms/components/form-builder/enums/FormControlType';
import { ControlSize } from '../../../../../enums/ControlSize';
import { TimeFrame } from '../../../enum/TimeFrame';

export const fileDateControls: FilterControlSettings = {
  [ViewFilterName._FileDate]: {
    type: FormControlType.TimeFrameSelect,
    name: ViewFilterName._FileDate,
    props: {
      timeFrameName: ViewFilterName.FileDateTimeFrame,
      timeFrames: [
        TimeFrame.Week,
        TimeFrame.Month,
        TimeFrame.Quarter,
        TimeFrame.YTD,
        TimeFrame.Year,
        TimeFrame.TwoYears,
        TimeFrame.FiveYears,
      ],
      minName: ViewFilterName.FileDateStartDate,
      maxName: ViewFilterName.FileDateEndDate,
      size: ControlSize.Small,
      isUnselectAvailable: true,
    },
  },
};
